import { isPossiblePhoneNumber, isPossibleNumber } from 'libphonenumber-js';
import { CountryCode } from 'typescript/constants/localization';

/**
 * libphonenumber-js can throw instead of returning false (ParseError
 * 'TOO_SHORT' crashed the checkout payment page via the error boundary in
 * production; non-string input throws a TypeError; unrecognized country
 * codes throw 'Unknown country'). Callers only use these checks for
 * cosmetic hints (maxlength) or validation, so degrade to `false` instead
 * of throwing.
 */

/**
 * Throw-safe wrapper around isPossiblePhoneNumber (expects a complete
 * phone number)
 * @returns false when the input is not a possible phone number or
 * libphonenumber-js throws
 */
export const safeIsPossiblePhoneNumber = (
  value: unknown,
  countryCode: CountryCode,
): boolean => {
  try {
    return (
      typeof value === 'string' && isPossiblePhoneNumber(value, countryCode)
    );
  } catch {
    return false;
  }
};

/**
 * Throw-safe wrapper around isPossibleNumber (accepts national /
 * partially-entered numbers)
 * @returns false when the input is not a possible phone number or
 * libphonenumber-js throws
 */
export const safeIsPossibleNumber = (
  value: unknown,
  countryCode: CountryCode,
): boolean => {
  try {
    return typeof value === 'string' && isPossibleNumber(value, countryCode);
  } catch {
    return false;
  }
};
